import gql from 'graphql-tag';

export default gql`
  query createOrderContent($selectedRow: AccountRowInput, $date: String) {
    createOrderContent(selectedRow: $selectedRow) {
      disabledDates {
        holidays
        days
      }
      minDate
      maxDate
      typeOptions {
        id
        text
        value
      }
      coopOptions {
        id
        text
        value
      }
      isValidDate(date: $date)
      orderTypesWithDatePicker
    }
  }
`;
